import React from 'react'
import { formatDateSymbol } from '../../../../utils/constant';

export default function SalesSummaryCompareTable(
  {
    activeTab,
    metaData,
    data,
    selectedColumnsList,
    type,
    setParams,
    params
  }
) {
  const periods = metaData.periods;
  return (
    <div
      className="report-table-container"
      style={{ height: 'calc(100vh - 380px)' }}
    >
      <table className="report-table">
        <thead>
          <tr>
            <th
              rowSpan={2}
              className={`${type === 'compareTable' ? 'name-col' : 'text-left cursor-pointer'} `}
              style={{ textAlign: 'left' }}
            >
              <div className="d-flex justify-content-start align-items-center gap-4">Metric</div>
            </th>
            {type === 'compareTable' &&
              periods.map((p, i) => (
                <th
                  key={i}
                  colSpan={1}
                >
                  {`${formatDateSymbol(p.from_date)} - ${formatDateSymbol(p.to_date)}`}
                </th>
              ))}
          </tr>
        </thead>
        <tbody>
          {selectedColumnsList.map((column) => (
            <tr>
              <td className='name-col'>{column.label}</td>
              {periods.map((p, i) => {
                const key = p.label;
                return data.map((m, idx) => {
                  const row = m.metrics[key];
                  return <td key={`${i}-${idx}`}>{row[column.key] ?? 0}</td>
                });
              })}
            </tr>
          ))}


        </tbody>
      </table>
    </div>
  )
}
